import { EmailAuthProvider, reauthenticateWithCredential, signOut } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functionsClient } from "./firebase";

const deleteMyAccountCallable = httpsCallable<Record<string, never>, { ok: true }>(
  functionsClient,
  "deleteMyAccount"
);

export async function deleteCurrentAccount(password: string) {
  const user = auth.currentUser;
  if (!user?.email) throw new Error("Aucun compte avec une adresse email n’est connecté.");
  if (!password) throw new Error("Saisis ton mot de passe pour confirmer ton identité.");

  await reauthenticateWithCredential(user, EmailAuthProvider.credential(user.email, password));
  await deleteMyAccountCallable({});
  await signOut(auth);
}

export function accountDeletionErrorMessage(error: unknown, fallback: string) {
  const value = error as {
    code?: unknown;
    message?: unknown;
    details?: { reason?: unknown };
  } | null;
  const reason = value?.details?.reason;
  if (reason === "owned-resources" || reason === "recent-auth-required") {
    return typeof value?.message === "string" ? value.message : fallback;
  }
  return fallback;
}
